document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get("hdn") === "true") {
    const classNames = [
      "shopify-section-group-abi-json__header_common",
      "hideable_class",
    ];
    for (className of classNames) {
      const elements = document.getElementsByClassName(className);
      for (element of elements) {
        if (element) {
          element.style.display = "none";
        }
      }
    }
  }
});
